import React from 'react';
import { Button } from 'react-bootstrap';

import Table from '../../../../../facturotopia/table/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const EntidadList = ({ data = [], onEdit, onListChange, onContabilidadAdd }) => {

  const handleEdit = (item) => {
    onEdit(item);
  }

  const handleDelete = (item) => {
    onListChange(item);
  }

  const handleContabilidadAdd = (item) => {
    onContabilidadAdd(item);
  }

  return (
    <>
      <Table
        columns={ columns(handleEdit, handleDelete, handleContabilidadAdd) }
        rowKey={ 'id' }
        data={ data }
      >
      </Table>
    </>
  );
}

const columns = (handleEdit, handleDelete, handleContabilidadAdd) => [
  {
    align: 'center',
    key: '__',
    title: '',
    dataIndex: '__',
    render: (item) => {
      return (
        <>
          <Button
            variant="secondary"
            size="sm"
            onClick={ handleEdit.bind(null, item)}
          >
            <FontAwesomeIcon icon={ ['far', 'edit'] } />
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={ handleDelete.bind(null, item)}
          >
            <FontAwesomeIcon icon={ ['fas', 'trash'] } />
          </Button>
          <Button
            variant="primary"
            size="sm"
            onClick={ handleContabilidadAdd.bind(null, item)}
          >
            <FontAwesomeIcon icon={ ['fas', 'plus'] } />
            {' '} Agregar contabilidad
          </Button>
        </>
      );
    }
  },
  {
    align: 'center',
    key: 'ClaveEntidad',
    title: 'Clave entidad',
    dataIndex: 'ClaveEntidad',
  },
  {
    align: 'center',
    key: 'Ambito',
    title: 'Ambito',
    dataIndex: 'Ambito',
  },
];

export default EntidadList;